import propTypes from 'prop-types';
import { useTheme } from 'styled-components';

const SvgOpenDoorIcon = ({ size, color, ...props }) => {
  const theme = useTheme();

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 212 332"
      fill={theme.colors[color] || color}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 324C0 319.582 3.58172 316 8 316H204C208.418 316 212 319.582 212 324C212 328.418 208.418 332 204 332H7.99999C3.58172 332 0 328.418 0 324Z"
        fill="inherit"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M80.1934 36.4745C73.5311 38.5729 69 44.7505 69 51.7355V248.265C69 255.249 73.5311 261.427 80.1934 263.525L175.193 293.447C185.503 296.694 196 288.995 196 278.186V21.8142C196 11.005 185.503 3.30602 175.193 6.55326L80.1934 36.4745ZM87 174C92.5228 174 97 166.837 97 158C97 149.163 92.5228 142 87 142C81.4772 142 77 149.163 77 158C77 166.837 81.4772 174 87 174Z"
        fill="inherit"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32 0C23.1634 0 16 7.16345 16 16V284C16 292.837 23.1634 300 32 300H180C188.837 300 196 292.837 196 284V16C196 7.16344 188.837 0 180 0H32ZM40 16C35.5817 16 32 19.5817 32 24V276C32 280.418 35.5817 284 40 284H172C176.418 284 180 280.418 180 276V32C180 23.1634 172.837 16 164 16H40Z"
        fill="inherit"
      />
    </svg>
  );
};

export default SvgOpenDoorIcon;

SvgOpenDoorIcon.propTypes = {
  size: propTypes.string,
  color: propTypes.string,
};

SvgOpenDoorIcon.defaultProps = {
  size: '16px',
  color: 'highBlack',
};
